import { render, staticRenderFns } from "./Doughnut2.vue?vue&type=template&id=0a176746"
import script from "./Doughnut2.vue?vue&type=script&lang=js"
export * from "./Doughnut2.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports